import { StorageService } from 'shared/storage';

type SessionStorageItem = 'viewedOffers';

type OfferToken = string;

export class OffersSessionStorage extends StorageService<SessionStorageItem> {

    private static instance?: OffersSessionStorage;

    private constructor() {
        super('candidateOffers', window.sessionStorage);
    }

    public static getInstance() {
        if (!this.instance) {
            this.instance = new OffersSessionStorage();
        }

        return this.instance;
    }

    public getViewedOfferTokens(): OfferToken[] {
        return this.getItem<OfferToken[]>('viewedOffers', []);
    }

    public addViewedOffer(offerToken: string) {
        const prevTokens = this.getViewedOfferTokens();

        this.setItem('viewedOffers', [ ...prevTokens, offerToken ]);
    }

}
